var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.authorized ? _c(_vm.SkinComponent, {
    tag: "component",
    attrs: {
      "code": _vm.code,
      "board": _vm.board
    }
  }) : _c('v-container', [_c('v-card', {
    staticClass: "pa-4",
    attrs: {
      "tile": "",
      "outlined": "",
      "elevation": "0"
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center",
    attrs: {
      "for": "qna-validate"
    }
  }, [_c('label', {
    staticClass: "text-center",
    attrs: {
      "for": "qna-validate"
    }
  }, [_vm._v("게시글 열람을 위해 "), _c('br', {
    staticClass: "b-lg-none"
  }), _vm._v("비밀번호를 입력해주세요.")])]), _c('v-card-text', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "input-inline-button"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filter.password,
      expression: "filter.password"
    }],
    staticClass: "input",
    attrs: {
      "maxlength": "6",
      "type": "password",
      "id": "qna-validate"
    },
    domProps: {
      "value": _vm.filter.password
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "password", $event.target.value);
      }
    }
  }), _c('button', {
    staticClass: "button button--primary",
    on: {
      "click": _vm.search
    }
  }, [_vm._v("확인")])])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }